export const AdviceIcon = (props: {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.width}
      viewBox="0 0 217 187"
      enableBackground="new 0 0 217 187"
    >
      <path
        fill="#FBFDFE"
        opacity="1.000000"
        stroke="none"
        d="
          M1.000000,187.000000 
          C1.000000,125.000008 1.000000,63.000015 1.000000,1.000017 
          C73.333321,1.000011 145.666641,1.000011 217.999969,1.000005 
          C217.999969,63.333309 217.999969,125.666618 217.999985,187.999969 
          C217.000000,188.000000 216.000000,188.000000 214.471664,187.709412 
          C213.828949,187.261353 213.714584,187.103851 213.700272,186.510437 
          C213.553253,183.730988 213.306198,181.387451 213.200958,178.750610 
          C213.188034,177.654221 213.033295,176.851120 212.921906,175.632339 
          C210.891495,151.005417 208.849869,126.791367 206.734528,102.583755 
          C204.807404,80.530228 202.888535,58.474895 200.694138,36.447453 
          C200.470932,34.206921 198.873856,31.098589 197.046631,30.240416 
          C193.676971,28.657810 192.316788,32.057083 190.967026,34.548622 
          C186.212616,43.324951 181.355057,52.047554 176.753464,60.903198 
          C175.410675,63.487389 173.799149,64.404503 170.912186,64.361786 
          C160.082901,64.201508 149.247925,64.185226 138.419418,64.369560 
          C135.338516,64.422005 133.608444,63.441528 132.187424,60.702293 
          C127.515083,51.695629 122.734192,42.736366 117.641670,33.964008 
          C116.606224,32.180344 114.030952,31.290571 112.165535,29.988720 
          C110.893608,31.877337 108.864891,33.630524 108.497932,35.681091 
          C107.563171,40.904575 107.360382,46.259975 106.883041,51.564240 
          C104.630463,76.595375 102.295692,101.619537 100.163330,126.660934 
          C98.454514,146.728531 96.994064,166.817261 95.203255,186.865692 
          C94.983124,186.834747 94.541428,186.885330 94.107414,186.919312 
          C62.782269,186.968857 31.891134,186.984421 1.000000,187.000000 
          M43.041965,65.404701 
          C43.400246,63.953232 43.856300,62.518005 44.100586,61.047600 
          C45.463013,52.846863 42.523495,46.276089 36.001694,41.437614 
          C29.492268,36.608326 20.269999,36.579079 13.452487,40.930202 
          C6.692353,45.244705 3.042554,53.200054 4.413304,60.632633 
          C6.142877,70.010841 12.302360,76.224403 21.472569,77.841652 
          C29.857630,79.320442 37.769779,74.927368 43.041965,65.404701 
          M64.696297,104.042793 
          C66.638069,103.718681 68.655739,103.628662 70.507927,103.028214 
          C77.048050,100.908012 80.765266,95.597855 80.705399,88.786835 
          C80.647285,82.176819 76.618439,76.851089 70.084793,74.747513 
          C64.173340,72.844254 57.486610,75.059784 53.759167,80.290619 
          C46.719765,90.169250 53.403728,102.659157 64.696297,104.042793 
          z"
      />
      <path
        fill="#944380"
        opacity="1.000000"
        stroke="none"
        d="
          M94.541428,186.885330 
          C94.541428,186.885330 94.983124,186.834747 95.715530,186.895325 
          C135.498703,186.952713 174.549469,186.949539 213.600235,186.946365 
          C213.714584,187.103851 213.828949,187.261353 213.971664,187.709412 
          C174.645767,188.000000 135.291550,188.000000 95.386658,187.707901 
          C94.737808,187.238968 94.639618,187.062149 94.541428,186.885330 
          z"
      />
      <path
        fill="#FAF2DC"
        opacity="1.000000"
        stroke="none"
        d="
          M94.107414,186.919312 
          C94.639618,187.062149 94.737808,187.238968 94.917999,187.707901 
          C63.666668,188.000000 32.333332,188.000000 1.000000,187.500000 
          C31.891134,186.984421 62.782269,186.968857 94.107414,186.919312 
          z"
      />
      <path
        fill="#7E2481"
        opacity="1.000000"
        stroke="none"
        d="
          M213.700272,186.510437 
          C174.549469,186.949539 135.498703,186.952713 95.935661,186.926254 
          C96.994064,166.817261 98.454514,146.728531 100.163330,126.660934 
          C102.295692,101.619537 104.630463,76.595375 106.883041,51.564240 
          C107.360382,46.259975 107.563171,40.904575 108.497932,35.681091 
          C108.864891,33.630524 110.893608,31.877337 112.165535,29.988720 
          C114.030952,31.290571 116.606224,32.180344 117.641670,33.964008 
          C122.734192,42.736366 127.515083,51.695629 132.187424,60.702293 
          C133.608444,63.441528 135.338516,64.422005 138.419418,64.369560 
          C149.247925,64.185226 160.082901,64.201508 170.912186,64.361786 
          C173.799149,64.404503 175.410675,63.487389 176.753464,60.903198 
          C181.355057,52.047554 186.212616,43.324951 190.967026,34.548622 
          C192.316788,32.057083 193.676971,28.657810 197.046631,30.240416 
          C198.873856,31.098589 200.470932,34.206921 200.694138,36.447453 
          C202.888535,58.474895 204.807404,80.530228 206.734528,102.583755 
          C208.849869,126.791367 210.891495,151.005417 212.699951,175.786804 
          C212.642822,177.252609 212.850983,178.148270 213.059143,179.043915 
          C213.306198,181.387451 213.553253,183.730988 213.700272,186.510437 
          M141.579559,108.929268 
          C143.717209,105.147385 142.437653,100.925667 138.205444,97.796768 
          C134.372650,94.963158 129.210266,95.324699 125.236900,98.926300 
          C120.115875,103.830292 120.400497,110.055199 126.307808,115.487938 
          C126.856667,115.682198 127.405525,115.876457 128.564041,116.157936 
          C128.972717,116.196915 129.381378,116.235886 130.084839,116.898872 
          C134.075226,119.254868 136.915039,116.401253 139.595734,114.363960 
          C140.614578,113.589661 140.396561,111.187897 140.684311,109.321167 
          C140.684311,109.321167 140.838058,109.171303 141.579559,108.929268 
          M174.100311,116.885056 
          C178.617554,118.563362 184.156113,116.011406 186.040207,111.383614 
          C188.364990,105.673363 186.603256,100.302780 181.389450,97.205940 
          C176.772430,94.463570 171.613266,95.873199 166.934540,101.873291 
          C164.610825,110.063538 166.717712,114.472137 174.100311,116.885056 
          z"
      />
      <path
        fill="#424A4B"
        opacity="1.000000"
        stroke="none"
        d="
          M42.856380,65.738220 
          C37.769779,74.927368 29.857630,79.320442 21.472569,77.841652 
          C12.302360,76.224403 6.142877,70.010841 4.413304,60.632633 
          C3.042554,53.200054 6.692353,45.244705 13.452487,40.930202 
          C20.269999,36.579079 29.492268,36.608326 36.001694,41.437614 
          C42.523495,46.276089 45.463013,52.846863 44.100586,61.047600 
          C43.856300,62.518005 43.400246,63.953232 42.856380,65.738220 
          M24.496592,73.464470 
          C25.637276,73.248077 26.789244,73.078629 27.916792,72.807587 
          C34.613811,71.197754 39.088612,65.988884 39.709690,59.116589 
          C40.313892,52.431046 36.614666,46.307274 30.353882,43.628792 
          C24.177994,40.986629 17.094568,42.584946 12.667356,47.582573 
          C5.076208,56.151783 8.921291,71.862465 24.496592,73.464470 
          z"
      />
      <path
        fill="#444C4D"
        opacity="1.000000"
        stroke="none"
        d="
          M64.279465,103.998177 
          C53.403728,102.659157 46.719765,90.169250 53.759167,80.290619 
          C57.486610,75.059784 64.173340,72.844254 70.084793,74.747513 
          C76.618439,76.851089 80.647285,82.176819 80.705399,88.786835 
          C80.765266,95.597855 77.048050,100.908012 70.507927,103.028214 
          C68.655739,103.628662 66.638069,103.718681 64.279465,103.998177 
          M58.936123,81.325714 
          C54.728172,86.973000 54.564178,92.061150 58.458424,96.147110 
          C61.762478,99.613808 67.170586,100.299767 71.237068,97.767921 
          C76.183205,94.688393 77.681190,88.825562 74.792694,83.851944 
          C71.786346,78.675407 66.149101,77.569519 58.936123,81.325714 
          z"
      />
      <path
        fill="#944380"
        opacity="1.000000"
        stroke="none"
        d="
            M213.200958,178.750610 
            C212.850983,178.148270 212.642822,177.252609 212.656616,176.202484 
            C213.033295,176.851120 213.188034,177.654221 213.200958,178.750610 
            z"
      />
      <path
        fill="#2A3539"
        opacity="1.000000"
        stroke="none"
        d="
          M129.790054,116.274857 
          C129.381378,116.235886 128.972717,116.196915 128.108261,115.851730 
          C127.092178,115.361710 126.531868,115.177910 125.971558,114.994110 
          C120.400497,110.055199 120.115875,103.830292 125.621109,99.132706 
          C126.297386,99.901024 126.589462,100.462944 127.261414,101.125153 
          C130.109268,102.691437 133.488800,103.633125 134.735870,105.801331 
          C135.618408,107.335754 133.615448,110.529808 132.568710,113.051559 
          C131.421249,114.171700 130.605652,115.223282 129.790054,116.274857 
          z"
      />
      <path
        fill="#293438"
        opacity="1.000000"
        stroke="none"
        d="
          M173.801849,116.242874 
          C166.717712,114.472137 164.610825,110.063538 167.443741,101.466110 
          C169.836334,101.200508 171.719711,101.342087 173.975418,101.485992 
          C180.583572,103.964203 181.442230,107.702126 176.909805,114.119415 
          C175.674530,114.945045 174.738190,115.593964 173.801849,116.242874 
          z"
      />
      <path
        fill="#4F4D55"
        opacity="1.000000"
        stroke="none"
        d="
          M173.603104,101.483673 
          C171.719711,101.342087 169.836334,101.200508 167.543518,101.079903 
          C171.613266,95.873199 176.772430,94.463570 181.389450,97.205940 
          C186.603256,100.302780 188.364990,105.673363 186.040207,111.383614 
          C184.156113,116.011406 178.617554,118.563362 173.951080,116.563965 
          C174.738190,115.593964 175.674530,114.945045 177.276398,114.087494 
          C182.524338,112.762077 184.816147,109.631485 184.115707,105.445480 
          C183.388321,101.098259 179.415527,98.043365 175.197632,98.882408 
          C174.520432,99.017128 174.127472,100.580658 173.603104,101.483673 
          z"
      />
      <path
        fill="#DEDDDC"
        opacity="1.000000"
        stroke="none"
        d="
          M132.900574,112.983009 
          C133.615448,110.529808 135.618408,107.335754 134.735870,105.801331 
          C133.488800,103.633125 130.109268,102.691437 127.455399,100.785172 
          C134.530884,95.616501 140.320465,101.907379 140.838058,109.171303 
          C140.838058,109.171303 140.684311,109.321167 140.352600,109.469650 
          C137.649918,110.744972 137.070236,115.662338 132.900574,112.983009 
          z"
      />
      <path
        fill="#4D4B52"
        opacity="1.000000"
        stroke="none"
        d="
          M141.208801,109.050285 
          C140.320465,101.907379 134.530884,95.616501 127.075523,100.684875 
          C126.589462,100.462944 126.297386,99.901024 125.972641,98.997437 
          C129.210266,95.324699 134.372650,94.963158 138.205444,97.796768 
          C142.437653,100.925667 143.717209,105.147385 141.208801,109.050285 
          z"
      />
      <path
        fill="#4C4A52"
        opacity="1.000000"
        stroke="none"
        d="
          M132.568710,113.051559 
          C137.070236,115.662338 137.649918,110.744972 140.381592,109.573013 
          C140.396561,111.187897 140.614578,113.589661 139.595734,114.363960 
          C136.915039,116.401253 134.075226,119.254868 129.937439,116.586868 
          C130.605652,115.223282 131.421249,114.171700 132.568710,113.051559 
          z"
      />
      <path
        fill="#4C4A52"
        opacity="1.000000"
        stroke="none"
        d="
          M126.139679,115.241028 
          C126.531868,115.177910 127.092178,115.361710 127.803436,115.808121 
          C127.405525,115.876457 126.856667,115.682198 126.139679,115.241028 
          z"
      />
      <path
        fill="#F5F7F7"
        opacity="1.000000"
        stroke="none"
        d="
          M24.066128,73.454689 
          C8.921291,71.862465 5.076208,56.151783 12.667356,47.582573 
          C17.094568,42.584946 24.177994,40.986629 30.353882,43.628792 
          C36.614666,46.307274 40.313892,52.431046 39.709690,59.116589 
          C39.088612,65.988884 34.613811,71.197754 27.916792,72.807587 
          C26.789244,73.078629 25.637276,73.248077 24.066128,73.454689 
          z"
      />
      <path
        fill="#F4F5F5"
        opacity="1.000000"
        stroke="none"
        d="
          M59.259369,81.096916 
          C66.149101,77.569519 71.786346,78.675407 74.792694,83.851944 
          C77.681190,88.825562 76.183205,94.688393 71.237068,97.767921 
          C67.170586,100.299767 61.762478,99.613808 58.458424,96.147110 
          C54.564178,92.061150 54.728172,86.973000 59.259369,81.096916 
          z"
      />
      <path
        fill="#E0DEDD"
        opacity="1.000000"
        stroke="none"
        d="
          M173.975418,101.485992 
          C174.127472,100.580658 174.520432,99.017128 175.197632,98.882408 
          C179.415527,98.043365 183.388321,101.098259 184.115707,105.445480 
          C184.816147,109.631485 182.524338,112.762077 177.575333,113.910782 
          C181.442230,107.702126 180.583572,103.964203 173.975418,101.485992 
          z"
      />
    </svg>
  );
};
